import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Table, CheckSquare, Calendar, Image } from 'lucide-react';
export function DeliverableSection() {
  const deliverables = [{
    icon: BookOpen,
    text: 'El Diccionario del Cabello — Guía completa'
  }, {
    icon: Table,
    text: 'Tablas por tipo 1A–4C'
  }, {
    icon: CheckSquare,
    text: 'Checklists imprimibles'
  }, {
    icon: Calendar,
    text: 'Plan de 14 días'
  }, {
    icon: Image,
    text: 'Guías visuales para mascarillas y resultados esperados'
  }];
  return <section className="py-20 bg-cream-100" data-id="element-66">
      <div className="max-w-4xl mx-auto px-6" data-id="element-67">
        <FadeIn className="text-center mb-12" data-id="element-68">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-900" data-id="element-69">
            Qué recibes
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-70">
          {deliverables.map((item, i) => <FadeIn key={i} delay={i * 0.1} className={i === 0 ? 'md:col-span-2' : ''} data-id="element-71">
              <div className={`bg-white p-6 rounded-xl shadow-sm flex items-center gap-4 ${i === 0 ? 'border-2 border-terracotta/20' : 'border border-brown-900/5'}`} data-id="element-72">
                <div className="w-10 h-10 rounded-full bg-cream-100 flex items-center justify-center shrink-0 text-terracotta" data-id="element-73">
                  <item.icon className="w-5 h-5" data-id="element-74" />
                </div>
                <span className="text-lg font-medium text-brown-900" data-id="element-75">
                  {item.text}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}